/* eslint-disable max-len */
import { createGlobalStyle } from 'styled-components';

export default createGlobalStyle`
    @font-face {
        font-family: 'Pretendard';
        font-weight: 900;
        font-display: swap;
        src: local('Pretendard Black'), url('/assets/fonts/pretendard/woff2/Pretendard-Black.woff2') format('woff2'), url('assets/fonts/pretendard/woff/Pretendard-Black.woff') format('woff');
    }

    @font-face {
        font-family: 'Pretendard';
        font-weight: 800;
        font-display: swap;
        src: local('Pretendard ExtraBold'), url('/assets/fonts/pretendard/woff2/Pretendard-ExtraBold.woff2') format('woff2'), url('assets/fonts/pretendard/woff/Pretendard-ExtraBold.woff') format('woff');
    }

    @font-face {
        font-family: 'Pretendard';
        font-weight: 700;
        font-display: swap;
        src: local('Pretendard Bold'), url('/assets/fonts/pretendard/woff2/Pretendard-Bold.woff2') format('woff2'), url('assets/fonts/pretendard/woff/Pretendard-Bold.woff') format('woff');
    }

    @font-face {
        font-family: 'Pretendard';
        font-weight: 600;
        font-display: swap;
        src: local('Pretendard SemiBold'), url('/assets/fonts/pretendard/woff2/Pretendard-SemiBold.woff2') format('woff2'), url('assets/fonts/pretendard/woff/Pretendard-SemiBold.woff') format('woff');
    }

    @font-face {
        font-family: 'Pretendard';
        font-weight: 500;
        font-display: swap;
        src: local('Pretendard Medium'), url('/assets/fonts/pretendard/woff2/Pretendard-Medium.woff2') format('woff2'), url('assets/fonts/pretendard/woff/Pretendard-Medium.woff') format('woff');
    }

    @font-face {
        font-family: 'Pretendard';
        font-weight: 400;
        font-display: swap;
        src: local('Pretendard Regular'), url('/assets/fonts/pretendard/woff2/Pretendard-Regular.woff2') format('woff2'), url('assets/fonts/pretendard/woff/Pretendard-Regular.woff') format('woff');
    }

    @font-face {
        font-family: 'Pretendard';
        font-weight: 300;
        font-display: swap;
        src: local('Pretendard Light'), url('/assets/fonts/pretendard/woff2/Pretendard-Light.woff2') format('woff2'), url('assets/fonts/pretendard/woff/Pretendard-Light.woff') format('woff');
    }

    @font-face {
        font-family: 'Pretendard';
        font-weight: 200;
        font-display: swap;
        src: local('Pretendard ExtraLight'), url('/assets/fonts/pretendard/woff2/Pretendard-ExtraLight.woff2') format('woff2'), url('assets/fonts/pretendard/woff/Pretendard-ExtraLight.woff') format('woff');
    }

    @font-face {
        font-family: 'Pretendard';
        font-weight: 100;
        font-display: swap;
        src: local('Pretendard Thin'), url('/assets/fonts/pretendard/woff2/Pretendard-Thin.woff2') format('woff2'), url('assets/fonts/pretendard/woff/Pretendard-Thin.woff') format('woff');
    }


    @font-face {
        font-family: 'Spoqa Han Sans Neo';
        font-weight: 700;
        src: local('Spoqa Han Sans Neo Bold'),
        url('/assets/fonts/spoqaHanSansNeo/SpoqaHanSansNeo-Bold.woff2') format('woff2'),
        url('/assets/fonts/spoqaHanSansNeo/SpoqaHanSansNeo-Bold.woff') format('woff'),
        url('/assets/fonts/spoqaHanSansNeo/SpoqaHanSansNeo-Bold.ttf') format('truetype');
    }


    @font-face {
        font-family: 'Spoqa Han Sans Neo';
        font-weight: 500;
        src: local('Spoqa Han Sans Neo Medium'),
        url('/assets/fonts/spoqaHanSansNeo/SpoqaHanSansNeo-Medium.woff2') format('woff2'),
        url('/assets/fonts/spoqaHanSansNeo/SpoqaHanSansNeo-Medium.woff') format('woff'),
        url('/assets/fonts/spoqaHanSansNeo/SpoqaHanSansNeo-Medium.ttf') format('truetype');
    }

    @font-face {
        font-family: 'Spoqa Han Sans Neo';
        font-weight: 400;
        src: local('Spoqa Han Sans Neo Regular'),
        url('/assets/fonts/spoqaHanSansNeo/SpoqaHanSansNeo-Regular.woff2') format('woff2'),
        url('/assets/fonts/spoqaHanSansNeo/SpoqaHanSansNeo-Regular.woff') format('woff'),
        url('/assets/fonts/spoqaHanSansNeo/SpoqaHanSansNeo-Regular.ttf') format('truetype');
    }

    @font-face {
        font-family: 'Spoqa Han Sans Neo';
        font-weight: 300;
        src: local('Spoqa Han Sans Neo Light'),
        url('/assets/fonts/spoqaHanSansNeo/SpoqaHanSansNeo-Light.woff2') format('woff2'),
        url('/assets/fonts/spoqaHanSansNeo/SpoqaHanSansNeo-Light.woff') format('woff'),
        url('/assets/fonts/spoqaHanSansNeo/SpoqaHanSansNeo-Light.ttf') format('truetype');
    }

    @font-face {
        font-family: 'Spoqa Han Sans Neo';
        font-weight: 100;
        src: local('Spoqa Han Sans Neo Thin'),
        url('/assets/fonts/spoqaHanSansNeo/SpoqaHanSansNeo-Thin.woff2') format('woff2'),
        url('/assets/fonts/spoqaHanSansNeo/SpoqaHanSansNeo-Thin.woff') format('woff'),
        url('/assets/fonts/spoqaHanSansNeo/SpoqaHanSansNeo-Thin.ttf') format('truetype');
    }

    html {
        // font-size: 62.5%;
    }
    body {
        padding: 0;
        margin: 0;
    }
    h1, h2, h3, h4, h5, h6, p, dl, dt, dd, ul, li {
        margin:0;
        padding:0;
    }
    ul, li {
        list-style:none;
    }
    main, div, article, section, header, aside, footer {
        box-sizing: border-box;
    }
    a {
        text-decoration: none;
        &:link, &:visited {
            color: inherit;
        }
    }

    input:-webkit-autofill,
    input:-webkit-autofill:hover,
    input:-webkit-autofill:focus,
    input:-webkit-autofill:active {
        transition: background-color 5000s ease-in-out 0s;
        -webkit-transition: background-color 9999s ease-out;
        -webkit-box-shadow: 0 0 0px 1000px transport inset !important;
    }
`;
